import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const CreateSolution = ({ visible, handleClose, initialData = '', onSubmit }) => {
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            solutionId: initialData?.solutionId || '',
            solutionName: initialData?.solutionName || '',
        },
        validateOnMount: false,
        validateOnBlur: true,
        validationSchema: Yup.object({
            solutionName: Yup.string().required('Solution Name is required'),
        }),
        onSubmit: (values, { resetForm }) => {
            const payload = {
                solutionName: values.solutionName,
            };

            if (initialData?.solutionId) {
                payload.sp = "usp_UpdateSolution";
                payload.solutionId = initialData?.solutionId;
            } else {
                payload.sp = "usp_InsertSolution";
            }

            onSubmit(payload, onClose);
        },
    });

    const onClose = () => {
        formik.resetForm();
        handleClose();
    };

    useEffect(() => {
        if (initialData?.solutionId) {
            formik.setFieldValue('solutionId', initialData.solutionId);
            formik.setFieldValue('solutionName', initialData.solutionName);
        }
    }, [initialData]);

    return (
        <Modal
            title={initialData ? "Edit Solution" : "Create New Solution"}
            visible={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            centered
            width={500}
            className="custom-modal-header p-0"
            maskClosable={false}
        >
            <form onSubmit={formik.handleSubmit}>
                <div className="row g-3">
                    <div className="col-md-12">
                        <label className="form-label">Solution Name</label> <span className="text-danger">*</span>
                        <input
                            type="text"
                            className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                            placeholder="Enter Solution Name"
                            name="solutionName"
                            value={formik.values.solutionName}
                            onChange={formik.handleChange}
                        />
                        {formik.touched.solutionName && formik.errors.solutionName && (
                            <span style={{ color: 'red' }} role="alert">{formik.errors.solutionName}</span>
                        )}
                    </div>

                    <div className="modal-footer mt-3">
                        <button type="button" className="btn btn-light" onClick={onClose}>
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary ms-3">
                            {initialData ? "Update" : "Add"}
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

CreateSolution.propTypes = {
    visible: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    initialData: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
};

export default CreateSolution;
